import { render } from "./EloquentField.vue?vue&type=template&id=a0436310"
import script from "./EloquentField.vue?vue&type=script&lang=js"
export * from "./EloquentField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"EloquentField.vue"]])

export default __exports__